// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsCampaignAlertPreferencesUpdateResult = objectOf({
  campaign_id: string,
  webhook_endpoints: arrayOf(string),
  no_profile_emails: arrayOf(string),
  developers: arrayOf(string),
  upper_threshold: string,
  upper_recurrence_interval: string,
});
